<template>
  <router-view v-if="$route.meta.vApp" />
  <v-app app v-else>
    <v-overlay :value="( routing || loading ) && ! currentUser" :z-index="99999" :absolute="true">
      <v-progress-circular :size="70" :width="7" color="primary" indeterminate/>
    </v-overlay>
    <navigation ref="navigation" v-if="$route.meta.navBar" @confirm-logout="confirmLogout" />
    <app-bar v-if="$route.meta.appBar" @nav-click="navClick" @confirm-logout="confirmLogout" />
    <app-bar-mobile v-if="$route.meta.appBarMobile" @nav-click="navClick" @confirm-logout="confirmLogout" />
    <v-content>
      <snackbar ref="snackbar" />
      <router-view />
      <confirm ref="confirm" />
    </v-content>
    <!-- <app-footer /> -->

  </v-app>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import Navigation from "@/components/Navigation.vue"
import AppBar from "@/components/AppBar.vue"
import AppBarMobile from "@/components/AppBarMobile.vue"
import Confirm from '@/components/Confirm.vue'
import Snackbar from '@/components/Snackbar.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'App',
  data: () => ({
    miniVariant: false,
  }),
  computed: {
    ...mapState({
      loading: state => state.loading,
      routing: state => state.routing,
    }),
    requiresGuest(){
      return this.$route.params.requiresGuest
    },
    appRoot(){
      const maybeAppRoot = this.$route.matched && this.$route.matched[0] && this.$route.matched[0].meta.appRoot
      console.log( 'APP ROOT', this.$route, this.$router, this.$route.meta.appRoot, maybeAppRoot )
      return this.$route.meta.requiresGuest || this.$route.meta.appRoot
    },
    showAppRoot(){
      return ! this.currentUser || this.appRoot
    }
  },
  methods: {
    navClick(){
      this.$refs.navigation.toggleDrawer()
    },
    async confirmLogout(){
      try {
          console.log( 'confirmLogout', this.$root.$confirm )
          const logout = await this.$refs.confirm.open( 'Logout', 'Are you sure you want to logout?' )
          if( logout ){
              await this.$firebase.auth().signOut()
              // await this.$store.commit("user/LOGOUT_USER")
              this.$router.push({ name: 'Login' })
          }
      } catch( e ){

      }
    }
  },
  created(){
    if( this.isMobile ){
      this.drawer = false
    }
  },
  mounted(){
    if( ! this.$route.meta.vApp ){
      this.$root.$confirm = this.$refs.confirm.open
    }
    this.$root.$snackbar = this.$refs.snackbar
  },
  components:{
    Navigation,
    AppBar,
    Confirm,
    Snackbar,
    'app-footer': Footer,
    AppBarMobile
  }
};
</script>
<style>
@import url('https://fonts.googleapis.com/css?family=Montserrat:400,700&display=swap');
@import url('https://fonts.googleapis.com/css?family=Comfortaa&display=swap');
.v-content__wrap {
    background-color: var(--v-background-base);
}
body, .full-page-primary {
    background-color: #5555a5 !important;
}
#app .theme--light.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state) > .v-input__control > .v-input__slot fieldset {
  color: rgba(143, 143, 143, 0.38);
}
.v-btn {
  text-transform: none !important;
}
</style>